import Vue from "vue";
import VeeValidate from "vee-validate";

VeeValidate.Validator.extend("newsLetterEmailExists", {
    getMessage: () => "This email address is already subscribed to hibooks insights.",
    validate: (email) => {
        // TODO: use endpoint to check if email is used.
        const dummyEmail = "max@mctekk.com";
        return email !== dummyEmail;
    }
});

Vue.use(VeeValidate);
